import { declMod } from '@yandex-lego/i-bem-react';
export default declMod({
  type: 'navigation'
}, {
  block: 'menu',
  tag: 'ul'
});